import {useData} from "vike-react/useData";
import {ApiProfileUserData, ApiUserIntegrationType} from "#/src/definitions/ApiDefinitions";
import {getProfileUrl} from "#/src/utils/profile-url";
import {DataWrapped} from "#/src/definitions/AppDefinitions";
import {AvatarWithFallback} from "#/src/components/AvatarWithFallback";
import React from "react";

export function SidebarSocials() {
  const {data: profileData} = useData() as DataWrapped<ApiProfileUserData>;

  function render() {
    return <div className="col-xl-3">
      <div className="sidebar-user">
        <div className="author">
          <AvatarWithFallback user={profileData.user} className={"avatar avatar-120"}/>
          <a href={getProfileUrl(profileData.user)} className="author-link">{profileData.user.username}</a>
          {renderBio()}
        </div>
        {renderIntegrations()}
      </div>
    </div>
  }

  function renderBio() {
    if(profileData.user.bio) {
      return <div className={"text-bio"}>{profileData.user.bio}</div>
    }
    return <div className={"text-bio"}>Niestety nie wiemy za dużo o tym użytkowniku.</div>
  }

  function renderIntegrations() {
    if (profileData.user.integrations.length == 0) {
      return <></>
    }
    return <ul className="nav-user">
      {profileData.user.integrations.map(integration => {
        return <li key={integration.id} className="nav-user-item">
          <a href={getProfileUrl(profileData.user)} className="nav-user-link">
            {renderIntegrationIcon(integration.integrationType)}
            {integration.displayName}
          </a>
        </li>
      })}
    </ul>
  }

  function renderIntegrationIcon(type: ApiUserIntegrationType) {
    switch (type) {
      case ApiUserIntegrationType.DISCORD:
        return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <g fill="none" fillRule="evenodd">
            <path
              d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/>
            <path fill="#788ca0"
                  d="M15.003 4c.744 0 1.53.26 2.25.547l.527.216c1.26.528 1.968 1.636 2.517 2.853c.891 1.975 1.51 4.608 1.724 6.61c.102.95.127 1.906-.056 2.549c-.197.687-.867 1.173-1.518 1.555l-.322.183l-.334.186c-.172.096-.349.191-.525.284l-.522.27l-.717.357l-.577.284a1 1 0 1 1-.894-1.788l.79-.39l-.58-.609c-1.39.57-3.027.893-4.766.893c-1.739 0-3.376-.322-4.766-.893l-.58.608l.793.39a1 1 0 1 1-.894 1.79l-.544-.27c-.402-.2-.805-.398-1.203-.607l-.928-.505l-.321-.183c-.651-.382-1.322-.868-1.518-1.555c-.184-.643-.158-1.598-.057-2.55c.214-2.001.833-4.634 1.724-6.609c.549-1.217 1.257-2.325 2.517-2.853C7.059 4.413 8.072 4 9 4c.603 0 1.077.555.99 1.147A13.65 13.65 0 0 1 12 5c.691 0 1.366.05 2.014.148A1.012 1.012 0 0 1 15.004 4ZM8.75 10.5a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5m6.5 0a1.75 1.75 0 1 0 0 3.5a1.75 1.75 0 0 0 0-3.5"/>
          </g>
        </svg>;
      case ApiUserIntegrationType.GOOGLE:
        return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="currentColor"
                d="M3.064 7.51A9.996 9.996 0 0 1 12 2c2.695 0 4.959.991 6.69 2.605l-2.867 2.868C14.786 6.482 13.468 5.977 12 5.977c-2.605 0-4.81 1.76-5.595 4.123c-.2.6-.314 1.24-.314 1.9c0 .66.114 1.3.314 1.9c.786 2.364 2.99 4.123 5.595 4.123c1.345 0 2.49-.355 3.386-.955a4.6 4.6 0 0 0 1.996-3.018H12v-3.868h9.418c.118.654.182 1.336.182 2.045c0 3.046-1.09 5.61-2.982 7.35C16.964 21.105 14.7 22 12 22A9.996 9.996 0 0 1 2 12c0-1.614.386-3.14 1.064-4.49"/>
        </svg>;
      case ApiUserIntegrationType.FACEBOOK:
        return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="#788ca0" d="M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4z"/>
        </svg>;
      case ApiUserIntegrationType.STEAM:
        return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="#788ca0"
                d="M12.005 2c-5.25 0-9.556 4.05-9.964 9.198l5.36 2.214a2.823 2.823 0 0 1 1.593-.491c.053 0 .105.003.157.005l2.384-3.452v-.049c0-2.08 1.69-3.77 3.77-3.77a3.776 3.776 0 0 1 3.77 3.773c0 2.08-1.691 3.77-3.77 3.77h-.087l-3.397 2.426c0 .043.003.088.003.133A2.826 2.826 0 0 1 9 18.587a2.844 2.844 0 0 1-2.775-2.273l-3.838-1.589C3.574 18.923 7.428 22 12.006 22c5.522 0 9.998-4.477 9.998-10c0-5.522-4.477-10-9.999-10M7.08 16.667c.218.452.595.832 1.095 1.041a2.126 2.126 0 0 0 2.78-2.77a2.123 2.123 0 0 0-2.712-1.178l1.269.526a1.565 1.565 0 0 1-1.204 2.889zm10.74-7.245a2.516 2.516 0 0 0-2.513-2.512a2.513 2.513 0 1 0 2.513 2.512M15.312 7.53A1.89 1.89 0 0 1 17.2 9.418a1.89 1.89 0 0 1-1.888 1.888a1.887 1.887 0 1 1 0-3.776"/>
        </svg>;
    }
  }

  return render();
}